import BaseSearchButton from "NavBar/components/FloatingButtonPanel/SearchButton";
import { navSectionKeys } from "NavBar/navBarStore";

import { navAccentColors } from "UI/colors";

import { useClearSearch, useSearchValue } from "../signupsAndEventsStore";

import { useIsActive } from "./floatingSearchStore";
import {
  activeBackgroundColor,
  inactiveBackgroundColor,
} from "./styleConstants";

const PLACEHOLDER = "Search all signups...";
const DATA_CY_INPUT = "NavBar_FloatingSignupSearchInput";
const DATA_CY_CLOSE_BUTTON = "SignupsAndEvents_FloatingSearch_CloseButton";
const DATA_CY_SEARCH_BUTTON = "NavBar_FloatingSignupSearchButton";

const SearchButton = () => {
  const [searchValue, setSearchValue] = useSearchValue();
  const clearSearch = useClearSearch();
  const [isActive, setIsActive] = useIsActive();

  return (
    <BaseSearchButton
      isActive={isActive}
      setIsActive={setIsActive}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      onClearSearch={clearSearch}
      placeholder={PLACEHOLDER}
      dataCyInput={DATA_CY_INPUT}
      dataCyCloseButton={DATA_CY_CLOSE_BUTTON}
      dataCySearchButton={DATA_CY_SEARCH_BUTTON}
      inactiveBackgroundColor={inactiveBackgroundColor}
      activeBackgroundColor={activeBackgroundColor}
      glowColor={navAccentColors[navSectionKeys.signups][0]}
    />
  );
};

export default SearchButton;
